export const environment = {
  defaultLocale: 'en-US',
};
